import { checkSparkDataAvailable } from 'src/helpers/validationHelper';
import Empty from 'src/components/Empty';
import { variables } from 'src/Tenants';
import Button from 'src/components/Button';
import FontAwesomeIcon from 'src/components/Icon';
import React from 'react';

const SuitesEmptyState = ({ search, user, property, onAddSuite }: any) => {
  const shouldHideButton =
    checkSparkDataAvailable(property, user.roles[0].role.name) ||
    user.roles[0].role.name === 'Home Owner' ||
    user.roles[0].role.name === 'Occupant' ||
    user.roles[0].role.name === 'Strata Manager';

  return (
    <Empty
      headline={'No ' + variables.suites + ' yet'}
      strapline={
        'All ' +
        variables.suites +
        " you add will be listed here so it's easier for you to manage."
      }
      searchIsActive={search && search.suites ? search.suites : ''}
      cta={
        shouldHideButton ? null : (
          <Button
            color="teal"
            onClick={onAddSuite}
            icon={<FontAwesomeIcon glyph="home" weight="light" size="small" />}
            label={'Add ' + variables.Suite}
            size="small"
          />
        )
      }
      image={
        <img
          alt={'No ' + variables.suites + ' yet'}
          src="/assets/empty/suites.svg"
        />
      }
      direction={undefined}
    />
  );
};

export default SuitesEmptyState;
